export const wrapLabels = (labels, stringlen = 8) => {
    return labels.map((label) => {
        const words = label.split(' ');
        const lines = [];
        let currentLine = '';
        for (const word of words) {
            if (currentLine.length + word.length > stringlen) {
                lines.push(currentLine);
                currentLine = word;
            }
            else {
                currentLine += (currentLine ? ' ' : '') + word;
            }
        }
        lines.push(currentLine);
        return lines;
    });
};
